// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
//
// NOTE: these are real function DECLARATIONS that call through to the moved
// implementation, not reference copies (`export const x = importedX`) or
// pass-through re-exports (`export { x } from ...`) — both of those forms
// broke vi.mock("@/hooks/useAuth")'s automocking for this specific module
// (confirmed empirically: reference-copy form still left `authHook.useAuth`
// undefined after automock, breaking 157 tests across 16 files; a genuine
// function declaration in this module's own scope is what automock needs to
// find something to wrap).
import * as _useAuthModule from "@livingsyncs/ui";

export function useAuth() {
  return _useAuthModule.useAuth();
}
export function useHasRole(
  roleName: Parameters<typeof _useAuthModule.useHasRole>[0],
) {
  return _useAuthModule.useHasRole(roleName);
}
export function useCanAccessFacility(facilityId: string) {
  return _useAuthModule.useCanAccessFacility(facilityId);
}
export function useIsPlatformUser() {
  return _useAuthModule.useIsPlatformUser();
}
export function useIsManager() {
  return _useAuthModule.useIsManager();
}
export function useIsAdmin() {
  return _useAuthModule.useIsAdmin();
}
export function useCanManageAppointments() {
  return _useAuthModule.useCanManageAppointments();
}
export function useCanViewCalendar() {
  return _useAuthModule.useCanViewCalendar();
}
export function useCanViewStaff() {
  return _useAuthModule.useCanViewStaff();
}
export function useCanManageMedicalRecords() {
  return _useAuthModule.useCanManageMedicalRecords();
}
export function useCanCreateCareNotes() {
  return _useAuthModule.useCanCreateCareNotes();
}
export function useLogin() {
  return _useAuthModule.useLogin();
}
export function useLogout() {
  return _useAuthModule.useLogout();
}
export function useSignup() {
  return _useAuthModule.useSignup();
}
export function useUpdatePassword() {
  return _useAuthModule.useUpdatePassword();
}
export function useSetupTotp() {
  return _useAuthModule.useSetupTotp();
}
export function useMfaPreference() {
  return _useAuthModule.useMfaPreference();
}
export function useAllowedRoles() {
  return _useAuthModule.useAllowedRoles();
}
export function useAssumeRole() {
  return _useAuthModule.useAssumeRole();
}
export function useClearAssumedRole() {
  return _useAuthModule.useClearAssumedRole();
}
export function useIsAuditorGroupAdmin() {
  return _useAuthModule.useIsAuditorGroupAdmin();
}
export function useCanAccessAuditorGroup(auditorGroupId: string) {
  return _useAuthModule.useCanAccessAuditorGroup(auditorGroupId);
}
export function useIsExternalAuditor() {
  return _useAuthModule.useIsExternalAuditor();
}
export function useIsAuditor() {
  return _useAuthModule.useIsAuditor();
}
export function useUpdateProfile() {
  return _useAuthModule.useUpdateProfile();
}
export function useRequestPasswordReset() {
  return _useAuthModule.useRequestPasswordReset();
}
export function useConfirmPasswordReset() {
  return _useAuthModule.useConfirmPasswordReset();
}
export type AuthStep = _useAuthModule.AuthStep;
